module.exports = __webpack_public_path__ + "assets/green.4f90cf96.svg";